// Mock data for Vitled

const F = (ok, es, en) => ({ ok, es, en });

export const plans = [
  {
    id: "trial", nameKey: "plan_trial_name", price: 0,
    priceLabel: { en: "Free", es: "Gratis" },
    tagline: { en: "Start creating clips with AI", es: "Empieza a crear clips con IA" },
    highlight: false, cta: { en: "Start free", es: "Empezar gratis" },
    features: [
      F(true, "3 exportaciones gratis", "3 free exports"),
      F(true, "Detecta los mejores momentos automáticamente", "Auto-detects the best moments"),
      F(true, "Crea clips cortos con IA", "Create short clips with AI"),
      F(true, "Subtítulos automáticos básicos", "Basic auto captions"),
      F(false, "Con marca de agua Vitled", "With Vitled watermark"),
      F(false, "720p · calidad básica", "720p · basic quality"),
    ],
  },
  {
    id: "pro", nameKey: "plan_pro_name", price: 9.99,
    priceLabel: { en: "$9.99", es: "9,99$" },
    tagline: { en: "For creators who want to grow faster", es: "Para creadores que quieren crecer más rápido" },
    highlight: false, cta: { en: "Get Pro", es: "Elegir Pro" },
    features: [
      F(true, "40 exportaciones al mes", "40 exports per month"),
      F(true, "Sin marca de agua", "No watermark"),
      F(true, "Detecta momentos virales con IA", "AI detects viral moments"),
      F(true, "Subtítulos animados estilo viral", "Animated viral-style captions"),
      F(true, "1080p · 40 y 60 fps · alta calidad", "1080p · 40 & 60 fps · high quality"),
      F(true, "Títulos virales y hashtags con IA", "AI viral titles & hashtags"),
    ],
  },
  {
    id: "premium", nameKey: "plan_premium_name", price: 16.99,
    priceLabel: { en: "$16.99", es: "16,99$" },
    tagline: { en: "For creators who want to maximize views", es: "Para creadores que quieren maximizar sus visitas" },
    highlight: true, badge: { en: "Most popular", es: "Más popular" },
    cta: { en: "Get Premium", es: "Elegir Premium" },
    features: [
      F(true, "75 exportaciones al mes", "75 exports per month"),
      F(true, "Todo lo incluido en PRO", "Everything in PRO"),
      F(true, "Sin marca de agua", "No watermark"),
      F(true, "Subtítulos premium estilo TikTok/Reels", "Premium TikTok/Reels-style captions"),
      F(true, "Exportación 2K (1440p) · máxima nitidez", "2K (1440p) export · maximum sharpness"),
      F(true, "Procesamiento prioritario", "Priority processing"),
    ],
  },
  {
    id: "vip", nameKey: "plan_vip_name", price: 29.99,
    priceLabel: { en: "$29.99", es: "29,99$" },
    tagline: { en: "For professionals and agencies", es: "Para profesionales y agencias" },
    highlight: false, cta: { en: "Get VIP", es: "Elegir VIP" },
    features: [
      F(true, "150 exportaciones al mes", "150 exports per month"),
      F(true, "Sin marca de agua", "No watermark"),
      F(true, "Exportación 4K · máxima nitidez", "4K export · maximum sharpness"),
      F(true, "Procesamiento prioritario", "Priority processing"),
      F(true, "Herramientas avanzadas de IA", "Advanced AI tools"),
      F(true, "Acceso anticipado a nuevas funciones", "Early access to new features"),
      F(true, "Soporte premium", "Premium support"),
    ],
  },
];

export const videoSources = [
  { id: "youtube", name: "YouTube", color: "#FF0033", sample: "youtube.com/watch?v=...", desc: { en: "Any public YouTube video — podcasts, interviews, gaming.", es: "Cualquier vídeo público de YouTube — podcasts, entrevistas, gaming." } },
  { id: "vimeo", name: "Vimeo", color: "#1AB7EA", sample: "vimeo.com/1234567", desc: { en: "Public and unlisted Vimeo videos work from the link.", es: "Vídeos públicos y privados de Vimeo desde el enlace." } },
  { id: "kick", name: "Kick", color: "#53FC18", sample: "kick.com/video/...", desc: { en: "Turn your Kick stream VODs into viral clips.", es: "Convierte tus VODs de Kick en clips virales." } },
  { id: "twitch", name: "Twitch", color: "#9146FF", sample: "twitch.tv/videos/...", desc: { en: "Turn your Twitch VODs into viral clips.", es: "Convierte tus VODs de Twitch en clips virales." } },
  { id: "upload", name: "File Upload", color: "#FACC15", sample: "MP4 · MOV · WEBM", desc: { en: "Drag & drop your footage and let the AI find the best moments.", es: "Arrastra tu vídeo y deja que la IA encuentre lo mejor." } },
];

export const captionStyles = [
  { id: "bold-yellow", name: "Bold Yellow", className: "font-black text-yellow-400" },
  { id: "white-outline", name: "White Outline", className: "font-bold text-white" },
  { id: "karaoke", name: "Karaoke", className: "font-extrabold text-yellow-300" },
  { id: "minimal", name: "Minimal", className: "font-semibold text-white" },
];
